export default {"src":"/_next/static/media/logo-3.3248fe52.svg","height":38,"width":65,"blurWidth":0,"blurHeight":0};